var _g, _rect, _g2, _rect2, _rect3, _rect4, _g3, _rect5, _rect6, _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallSimulationSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 32,
    viewBox: "0 0 185 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_537_30733)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 10,
    width: 136,
    height: 98,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 10.25,
    width: 135.5,
    height: 97.5,
    rx: 5.75,
    stroke: "#EBEDF5",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    width: 116,
    height: 26,
    rx: 4,
    fill: "white",
    stroke: "#D0D5EA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_537_30733)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 136,
    height: 30,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 26.1,
    width: 135.8,
    height: 29.8,
    rx: 3.9,
    stroke: "#DDE3EC",
    strokeWidth: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 35,
    width: 47.8066,
    height: 3.49805,
    rx: 1.16602,
    fill: "#E4E6EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43.1641,
    width: 33.8145,
    height: 3.49805,
    rx: 1.16602,
    fill: "#E4E6EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#E4E6EF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_537_30733)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 62,
    width: 138,
    height: 28,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1,
    y: 62.1,
    width: 137.8,
    height: 27.8,
    rx: 2.9,
    stroke: "#DDE3EC",
    strokeWidth: 0.2
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 70,
    width: 25.4375,
    height: 3.28227,
    rx: 1.64114,
    fill: "#E4E6EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 77.6562,
    width: 30.737,
    height: 3.28227,
    rx: 1.64114,
    fill: "#E4E6EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1429 67H47.6364C46.7326 67 46 67.7326 46 68.6364C46 77.6738 53.3262 85 62.3636 85C63.2674 85 64 84.2674 64 83.3636V79.8571L60.1429 77.2857L58.1428 79.2857C57.7955 79.6331 57.2763 79.7412 56.8399 79.5157C56.0996 79.1333 54.8984 78.4147 53.7143 77.2857C52.502 76.1298 51.7916 74.8842 51.4351 74.1304C51.2353 73.708 51.351 73.2204 51.6814 72.89L53.7143 70.8571L51.1429 67Z",
    fill: "#E4E6EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 85,
    r: 13,
    fill: "#3D9E69",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.5 85.8555L158 88.3555L164.5 80.3555",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_537_30733",
    x: 15,
    y: 0,
    width: 160,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_537_30733"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_537_30733",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_537_30733",
    x: 0,
    y: 20,
    width: 152,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_537_30733"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_537_30733",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_537_30733",
    x: 35,
    y: 58,
    width: 150,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_537_30733"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_537_30733",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSimulationSuccess);
export default __webpack_public_path__ + "static/media/CallSimulationSuccess.a81605f75fcf8a988a1cd5b04cfadb6a.svg";
export { ForwardRef as ReactComponent };